import React from "react";
import { RadioContainer } from "../../commons";
import { Warning } from "../../../assets/images";

type AppProps = {
  cancelComment: string;
  radioValue: string;
  data: any;
  eInvoiceAt:string | null;
  setCancelComment: (data: string) => void;
  setRadioValue: (data: string) => void;
  isEinvoicePresent: number;
};

export const REVERT_EINVOICE_OPTION = [
  { id: "1", name: "Duplicate entry" },
  { id: "2", name: "Wrong entry" },
  { id: "3", name: "Order cancel by buyer" },
  { id: "4", name: "Order cancel by seller" },
];

const EinvoiceRevert = ({
  cancelComment,
  data,
  radioValue,
  eInvoiceAt,
  setCancelComment,
  setRadioValue,
  isEinvoicePresent,
}: AppProps) => {
  return (
    <div className="e-invoice-revert-comment-box">
      <div className="sub-heading-e-invoice mb-4 ml-0">
        Your Comment or Reason For Cancelling The E-Invoice.
      </div>

      <div>
        <textarea
          disabled={isEinvoicePresent === 2 || (!!eInvoiceAt &&
            (+new Date(eInvoiceAt)?.getTime() +  86400000 < +new Date()))}
          style={{ width: "100%" }}
          value={cancelComment}
          placeholder="Add a comment"
          onChange={(text: any) => setCancelComment(text.target.value)}
        />
      </div>

      <div className="sub-heading-e-invoice mb-2 ml-0 mt-3">
        {isEinvoicePresent === 2
          ? "Reason To Cancel Your E-Invoice"
          : (!!eInvoiceAt &&
            (+new Date(eInvoiceAt)?.getTime() +  86400000 < +new Date())) ? null :"Reason To Cancel Your E-Invoice (Mandatory)"}
      </div>

      <div className="mb-2">
        {
          REVERT_EINVOICE_OPTION?.find(
            (item: any) => item?.id == data?.cancel_remark
          )?.name
        }
      </div>

      {(isEinvoicePresent === 1  && (!!eInvoiceAt  ?
            !(+new Date(eInvoiceAt)?.getTime() +  86400000 < +new Date()) : true) )? (
        <RadioContainer
          optionsList={REVERT_EINVOICE_OPTION}
          handleSetRadioValue={(radio: string) => setRadioValue(radio)}
          radioValue={radioValue}
          alignment="vertical"
        />
      ) : null}

      {isEinvoicePresent === 2 ? (
        <div className="sub-heading-e-invoice mb-1 mt-4 ml-0">
          Your Comment{" "}
        </div>
      ) : null}

      <div>{data?.cancel_reason}</div>

      {isEinvoicePresent !== 2 ? (
        <div className="alerts">
          <img width={"30px"} src={Warning} alt="warning" />
          You can only cancel an e-invoice within 24 hours of sending it.
        </div>
      ) : null}

 
    </div>
  );
};

export default EinvoiceRevert;
